var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import UIController from '../ui';
export default class RecipeCard {
    constructor(idMeal, strMeal, strMealThumb, strArea, strCategory, strSource) {
        this.idMeal = idMeal;
        this.strMeal = strMeal;
        this.strMealThumb = strMealThumb;
        this.strArea = strArea;
        this.strCategory = strCategory;
        this.strSource = strSource;
    }
    render() {
        return __awaiter(this, void 0, void 0, function* () {
            const li = document.createElement('li');
            li.id = this.idMeal;
            li.classList.add('list_recipecards_item');
            // get the country flag
            let flag = null;
            if (this.strArea !== undefined && this.strArea !== 'Unknown')
                flag = yield import(`../../images/flag_${this.strArea}.svg`);
            li.innerHTML = `
            <div class="recipe_image" id="image_${this.idMeal}">
                <div class="overlay"></div>
            </div>
            <div class="recipe_meta">
                <h2>${this.strMeal}</h2>

                ${flag
                ? `<h5>
                    <img src="${flag.default}" />
                    ${this.strArea} &nbsp; | &nbsp; ${this.strCategory}
                </h5>`
                : `<h5>&nbsp; ${this.strCategory}</h5>`}

                ${this.strSource
                ? `<p><a href="${this.strSource}" target="_blank">Source</a></p>`
                : ''}
            </div>
        `;
            li.onclick = () => __awaiter(this, void 0, void 0, function* () { return UIController.renderRecipe(this.idMeal); });
            return li;
        });
    }
}
